<template>
  <div class="app-container">
    <navigation title="请您关注"></navigation>
    <div class="content">
      <div class="content-header">
        <div class="logo-app">
          <img v-if="detail.logoPath" :src="baseUrl+detail.logoPath" alt="" class="list-img">
          <p>{{ detail.title }}</p>
        </div>
        <div class="down">
          <a :href="detail.link" v-if="detail.link">
            <button class="iphone"><svg-icon iconClass='iphone' className='icon'></svg-icon><span>iOS:iTunes下载</span></button>
          </a>
          <a :href="detail.filePath" v-if="detail.filePath">
            <button class="android"><svg-icon iconClass='android' className='icon'></svg-icon><span>Android本地下载</span></button>
          </a>
        </div>
      </div>
      <div class="desc" v-html="detail.descHtml"></div>
      <version></version>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import { request } from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'applicationDetails',
  components: {navigation, version},
  data () {
    return {
      detail: '',
      baseUrl: process.env.API_ROOT,
    }
  },
  created () {
    // 获取信息
    this.getDetail()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    getDetail () {
      request('get', '/nlc-web/api/app', {}, this.$route.query.id).then(res => {
        console.log('应用荟萃详情', res)
        this.detail = res.data
      })
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#f3f8fd;
  overflow-y:scroll;
  min-height:100%;
}
.content{
  width: 7.5rem;
  margin-top:.92rem;
  border-radius:8px;
  position:relative;
  background:url(../../assets/img/app-btm-bg.png) no-repeat center bottom;
  background-size:100%;
}
.content-header{
  min-height:3.55rem;
  background:url(../../assets/img/app-top-bg.png) no-repeat center top;
  background-size:100%;
}
.logo-app{
  width:100%;
  text-align:center;
  padding-top:.7rem;
}
.logo-app img{
  width:1.46rem;
  height:1.46rem;
}
.logo-app p{
  margin:0;
  font-size:.28rem;
  color:#47494C;
}
.down{
  width:100%;
  text-align: center;
  font-size:.24rem;
  color:#fff;
  margin-top:.4rem;
}
.down button{
  width:2.51rem;
  height:.88rem;
  border:none;
  border-radius: 8px;
  padding:0;
}
.down button span{
  margin-left:.04rem;
}
.iphone{
  background: #008094;
  box-shadow: -5px -5px 10px 0px rgba(184, 242, 255, 0.4);
}
.android{
  background: #DC8E2A;
  box-shadow: -5px -5px 10px 0px rgba(255, 236, 212, 0.31);
  margin-left:.6rem;
}
.desc{
  font-size:.24rem;
  color:#008095;
  margin:.39rem .64rem;
  min-height:6.9rem;
}
.down a{
  color:#fff;
}
.list-img{
  border-radius:16px;
}
</style>



// WEBPACK FOOTER //
// src/view/applicationDetails/index.vue